// LLM:METADATA
// :topology: [Domain:StateManagement | Role:StatePersistence | Pattern:Middleware]
// :relates-to: uses: "vuex", "vuex-persistedstate", required-by: "All Store Modules"
// :rationale: "Automatic state persistence prevents data loss on page reload"
// :contract: pre: "Store initialized", post: "State persisted to localStorage", invariant: "State is always recoverable"
// :decision_cache: "Chose vuex-persistedstate for automatic persistence [STATE-001]"
// LLM:END

import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"
import auth from "./modules/auth"
import dict from "./modules/dict"
import ui from "./modules/ui"
import app from "./modules/app"
import { setTopologyId } from "@/services/logger"
import { TOPOLOGY_STORE_INDEX } from "@/constants/topology"
import logger from "@/services/logger"
import { STATE_PERSIST_START, STATE_PERSIST_COMPLETE } from "@/constants/events"

// Set topology ID for semantic logging
setTopologyId(TOPOLOGY_STORE_INDEX)

// LLM:METADATA
// :topology: [Domain:StateManagement | Role:StatePersistence | Pattern:Middleware]
// :relates-to: uses: "vuex-persistedstate", required-by: "All Store Modules"
// :rationale: "Notifications are transient UI state and should NOT persist across page reloads. Removing from persistence path prevents sticky notifications after hard reload."
// :contract: pre: "Store initialized", post: "State persisted to localStorage (excluding notifications)", invariant: "Notifications are cleared on page refresh"
// :decision_cache: "Removed ui.notifications from persistence paths [FIX-NOTIF-PERSIST-001]"
// LLM:END

// Configure state persistence
const persistedState = createPersistedState({
  key: "editor-spa-state",
  storage: window.localStorage,
  paths: [
    "auth.userRole",
    "auth.userId",
    "app.params",
    "ui.pagesTransition",
    // NOTIFICATIONS: Transient only - do NOT persist across reloads
    // "ui.notifications",
  ],
})

export default createStore({
  modules: {
    auth,
    dict,
    ui,
    app,
  },
  plugins: [persistedState],
  strict: process.env.NODE_ENV !== "production",
})

// Log persistence events
logger.info(STATE_PERSIST_START, "State persistence configured", {
  key: "editor-spa-state",
  paths: [
    "auth.userRole",
    "auth.userId",
    "app.params",
    "ui.pagesTransition",
    // Notifications are transient - not persisted
  ],
  timestamp: Date.now(),
})

logger.info(STATE_PERSIST_COMPLETE, "State persistence ready", {
  timestamp: Date.now(),
})
